import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import CheckIcon from '@hapana/shared/web/styles/assets/svgs/check.svg'
import AlertDialog from '@hapana/shared/web/components/shared/dialog/alert-dialog/alert-dialog.component'
import {
  SIZES,
  VARIANTS,
} from '@hapana/shared/web/components/shared/dialog/alert-dialog/alert-dialog.constants'
import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'

export const AssignEquipmentSuccessAlert = ({ clientName, isTestMode, onOkay }) => {
  const { t } = useTranslation('checkIn')
  const { popDialog, popToDialog } = useDialog()

  return (
    <AlertDialog
      title={
        isTestMode
          ? t('checkIn:equipments.alerts.assignToEquipment.testSuccessTitle')
          : t('checkIn:equipments.alerts.assignToEquipment.successTitle', { name: clientName })
      }
      description={t('checkIn:equipments.alerts.assignToEquipment.successInUseDescription')}
      icon={CheckIcon}
      size={SIZES.XS}
      variant={VARIANTS.SUCCESS}
      closeAction={popDialog}
      primaryAction={{
        label: t('checkIn:okay'),
        action: () => {
          if (onOkay) {
            onOkay()
          } else {
            // Pop everything above the root ModalCheckIn (index 0), regardless of stack depth
            popToDialog((_, i) => i === 0, { defaultTab: isTestMode ? '3' : '1' })
          }
        },
      }}
    />
  )
}

AssignEquipmentSuccessAlert.propTypes = {
  clientName: PropTypes.string,
  onViewQueue: PropTypes.func,
  isTestMode: PropTypes.bool,
  onOkay: PropTypes.func,
}

export default AssignEquipmentSuccessAlert
